export default __webpack_public_path__ + "static/media/arras22.561145c2.jpg";